<template>
<div class="app-toast promptValue"  v-show="isShow" :class="[(type=='notice'||type=='note')?'yellow':'purple',type=='loginSuccess'?'green':'', type == 'fail2'?'app-toast-fail2':'']">
    <div class="status-info">
        <div class="status-info-box">
            <div class="icon-util info-success info-success-position" v-if="type==='success'"></div>
            <div class="icon-util info-fail info-success-position" v-if="type==='fail'"></div>
            <div class="icon-util info-fail info-success-position" v-if="type==='fail2'"></div>
            <div class="icon-util info-note info-success-position" v-if="type==='note'"></div>
            <div class="infonotebox-closer" style="cursor:pointer;" v-if="type==='notice'||type=='loginSuccess'" @click.stop="isShow=false"></div>
            <span ref="exceptionText"><span v-html="text"></span>
                <a v-if="multCloudShow&&type!='notice'" class="learn-more-exception" :style="'font-size: 14px;'" target="_blank" href="https://www.multcloud.com/">multcloud.com</a>
                <span v-if="toTaskShow&&type!='notice'" class="alink" @click="jumpToLogin('task')">{{vm.$t('language.sharesPage.createTransferSuccessAfter')}}</span>
                <span v-if="toSavedSharesShow&&type!='notice'" class="alink" @click="jumpToLogin('savedShare')">{{vm.$t('language.sharesPage.saveLinkSuccessAfter')}}</span>
            </span>

            <a v-if="learnMoreShow&&type!='notice'&&type!='note'" class="learn-more-exception" target="_blank" href="https://www.multcloud.com/help/solutions.html">{{vm.$t('language.meassage.leanMore')}}</a>
            <span v-if="type!='loginSuccess'" class="info-close" style="cursor:pointer;" @click.stop="isShow=false">{{vm.$t('language.common.close')}}</span>
            <span v-if="type=='loginSuccess'" class="operate" @click="skip()">{{vm.$t('language.meassage.skip')}}</span>
            <span v-if="type=='loginSuccess'" class="operate" style="left:-5px;/*no*/" @click="active()">{{vm.$t('language.meassage.activate')}}</span>

            
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    data() {
        return {
            vm: null,
            isShow: false,
            type:'',
            text:'',
            learnMoreShow:'',
            multCloudShow:'',
            toTaskShow:'',
            toSavedSharesShow:''
        }
    },
    created() {
        const vm = window.vm;
        this.vm = vm;
        let el = document.getElementsByClassName('promptValue');
        if (el.length) {
            for (let i = 0; i < el.length; i++) {
        if(!el[i].className.indexOf('app-toast-fail2')){
            el[i].style.display = 'none';
        }
            }
        }
    },
    methods: {
        skip() {
            this.vm.$children[0].$children[0].toMCMainPage();
        },
        active() {
            this.vm.$children[0].$children[0].reSendmessage();
            this.isShow = false;
        },
        jumpToLogin(open){
            // var lang = commonUtils.getLocaleToIndex();
            // lang = (lang=='en'||lang=='pt')?'':('/'+lang);
            // var res = commonstate.frontEndUrl+lang+"/login?open="+open;
            // return res;
            commonUtils.shareJumpToMcPorject(this,open);
        }
    }
}
</script>

<style scoped>
.operate {
    float: right;

}

.infonotebox-closer {
    /*no*/
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    margin-right: 10px;
    /*no*/
    background: url(../assets/images/vectorImg/icon_hint_green.svg) no-repeat bottom right;
}

.app-toast {
    position: fixed;
    top: 5px;
    /*no*/
    right: 0;
    left: 0;
    margin: auto;
    height: 40px;
    /*no*/
    font-size: 14px;
    /*no*/
    border-radius: 5px;
    /*no*/
    line-height: 40px;
    /*no*/
    color: #000;
    text-align: center;
    z-index: 900;
    width: fit-content;
    padding: 0 20px;/*no*/
}

.app-toast-fail2 {
    /* 使用!important确保覆盖其他样式 */
    top: 55px !important; 
}

.purple {
    background-color: #EAEEFA;
    border: 1px solid #BFCDFA;
    /*no*/
}

.yellow {
    background-color: #fef8b6;
    border: 1Px solid #f3da99 ! important;
}

.green {
    background-color: #dcf9b9;
    border: 1px solid #BDDE95 ! important;
    /*no*/
}

.status-info {
    position: relative;
    height: 40px;
    /*no*/
}

.status-info-box {
    margin: auto;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.message-box {
    float: right;
}

.info-close {
    font-size: 12px;
    /*no*/
    color: #6f7886;
    margin-left: 20px;
    /*no*/
    position: relative;

}

.operate {
    font-size: 14px;
    /*no*/
    color: green;
    margin-right: 5px;
    /*no*/
    position: relative;
    cursor: pointer;
}

.info-success {
    width: 20px;
    /*no*/

    height: 20px;
    /*no*/

    background-position: -2008px -763px;
    /*no*/

}

.info-fail {
    width: 20px;
    /*no*/

    height: 20px;
    /*no*/

    background-position: -2043px -763px;
    /*no*/

}

.info-note {
    width: 20px;/*no*/
    height: 20px;/*no*/
    background: url(../assets/images/workspace/icon_note.png) no-repeat center;
}

.info-success-position {
    position: relative;
    margin-right: 10px;
    /*no*/

}

.learn-more-exception {
    text-decoration: none;
    color: #4181ff;
    margin-left: 2px;
    /*no*/
    font-size: 10px;
    /*no*/
}

.learn-more-exception:hover {
    text-decoration: underline;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/messages/message.vue